import { Toast } from "vant"
import { getJsApiConfig } from '@/api/weixin';
import {isMobileTerminal} from "util/validate";

export const mixins = {
    data() {
        return {
            viewportHeight: 0,
			focusType: '',
            scanArr:[]
        }
    },

    created() {
        const that = this
    },

    mounted() {
        this.getWxConfig()
    },

    computed: {

    },

    methods: {

        getWxConfig(){
            let _this = this;
            let url = window.location.href;
            let prefix=window.localStorage.prefix;
            getJsApiConfig({url:url,prefix:prefix}).then(data=>{
                if(!data)return;
                if(!data.success){
                    _this.$notify({
                        type: "danger",
                        message: `获取js-sdk config信息失败:${data.msg}`,
                        duration: 3000
                    });
                } else {
                    const w = data.response
                    //微信 js-sdk 注入权限验证配置
                    this.$wx.config({
                        beta: true,
                        debug: false,
                        appId: w.appId,
                        timestamp: w.timestamp,
                        nonceStr: w.nonceStr,
                        signature: w.signature,
                        jsApiList: [
                            'checkJsApi',
                            'onMenuShareAppMessage',
                            'onMenuShareWechat',
                            'onMenuShareTimeline',
                            'shareAppMessage',
                            'shareWechatMessage',
                            'startRecord',
                            'stopRecord',
                            'onVoiceRecordEnd',
                            'playVoice',
                            'pauseVoice',
                            'stopVoice',
                            'uploadVoice',
                            'downloadVoice',
                            'chooseImage',
                            'previewImage',
                            'uploadImage',
                            'downloadImage',
                            'getNetworkType',
                            'openLocation',
                            'getLocation',
                            'hideOptionMenu',
                            'showOptionMenu',
                            'hideMenuItems',
                            'showMenuItems',
                            'hideAllNonBaseMenuItem',
                            'showAllNonBaseMenuItem',
                            'closeWindow',
                            'scanQRCode',
                            'previewFile',
                            'openEnterpriseChat',
                            'selectEnterpriseContact',
                            'onHistoryBack',
                            'openDefaultBrowser',
                        ]
                    });
        
                    this.$wx.ready(function(){
                        // Toast('weixin api 已准备好了')
                    })
                    this.$wx.error(function(res){
                        // Toast(`错误---${res}`)
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    });
                }
            });
        },

		forPC(){

			if(!isMobileTerminal()){
				setTimeout(function(){
					const btn = document.querySelector('.submit-box')
                    if(btn){
                        document.querySelector('.submit-box').style.display = 'none'
                    }
				})  
				setTimeout(function(){
					const btn = document.querySelector('.submit-box')
					if(btn){
						btn.style.display = 'block'
						btn.classList.add('mobileForPC')
					}     
				},500)  
			}
		},

		inputNum(target){
			let timeNow = target.timeStamp
			this.scanArr.push(timeNow)
			for(let i in this.scanArr){
				if(Math.ceil(this.scanArr[this.scanArr.length-1]) - Math.ceil(this.scanArr[this.scanArr.length-2])<30){
					this.$refs.scanInp.blur()
				}
			}
		},
    }
}